import React from "react";

import { FieldQueryItem, FieldQueryColumn } from "../../field-query.types";
import { Row } from "./components/row";

import "./body.styles.scss";

export type FieldQueryBodyProps = {
  rows: FieldQueryItem[];
  selectedRowId?: FieldQueryItem["id"];
  onItemClick: (item: FieldQueryItem) => void;
  columns: Array<FieldQueryColumn>;
  getId: {
    bodyRow: (params: { rowIndex: number }) => string;
    bodyRowCell: (params: { rowIndex: number; cellIndex: number }) => string;
  };
  classes?: {
    row?: string;
  };
  onRowDrop?: (dragIndex: number, hoverIndex: number) => void;
  enableDragDrop?: boolean;
};

export const Body: React.FC<FieldQueryBodyProps> = ({rows, selectedRowId, onItemClick, columns, getId, classes, onRowDrop, enableDragDrop = false}) => {
  return (
    <tbody className="FieldQueryTableBody">
      {rows.map((row, rowIndex) => (
        <Row
          selectedItem={selectedRowId === row.id}
          onClick={onItemClick}
          key={row.id}
          item={row}
          itemIndex={rowIndex}
          columns={columns}
          getId={getId}
          className={classes?.row}
          onRowDrop={onRowDrop}
          enableDragDrop={enableDragDrop}
        />
      ))}
    </tbody>
  );
};
